type LaborOwnerDepartureListener = () => void;

let ownerDeparting = false;
const listeners = new Set<LaborOwnerDepartureListener>();

/** True while the owning tab is silently clocking out as part of leaving a working page. */
export function isLaborOwnerDeparting(): boolean {
  return ownerDeparting;
}

export function setLaborOwnerDeparting(next: boolean): void {
  if (ownerDeparting === next) {
    return;
  }
  ownerDeparting = next;
  for (const listener of listeners) {
    listener();
  }
}

/** Marks this tab as silently clocking out for the duration of `work` (sync cache clears). */
export function runWhileLaborOwnerDeparting(work: () => void): void {
  setLaborOwnerDeparting(true);
  try {
    work();
  } finally {
    setLaborOwnerDeparting(false);
  }
}

export function subscribeLaborOwnerDeparting(listener: LaborOwnerDepartureListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
